import { useQueryClient } from '@tanstack/react-query';
import React from 'react';
import { useCreateConversation } from '~/hooks/useConversations';

import SendMessageForm from '../../ConversationsList/ConversationDetails/SendMessage/SendMessageForm';

function CreateConversationForm({ orderId, closeModal, setSelectedConversation, contactReason }) {
  const queryClient = useQueryClient();

  const onSuccessOfMutation = (data) => {
    setSelectedConversation(data.id);
    closeModal();
  };
  const createConversationMutation = useCreateConversation(orderId, queryClient, onSuccessOfMutation);

  const handleSubmit = (formData, options) => {
    if (contactReason) {
      formData.append('contact_reason', contactReason);
    }
    createConversationMutation.mutate(formData, options);
  };

  return (
    <SendMessageForm mutation={{ ...createConversationMutation, mutate: handleSubmit }} formName={`create-conversation-${orderId}`} disabled={!contactReason} />
  );
}

export default CreateConversationForm;
